module.exports = __webpack_public_path__ + "img/Hypoxia-PRCA_10X_ANS.66a30f1a.png";